export const TEST_ID = 'planWarnings';

export const WARNING_ITEM_TEST_ID = 'planWarningsItem';
